export function resolveNotificationLink(n: {
  resource_type: string | null;
  resource_id: number | null;
  link: string | null;
}): string | null {
  if (n.resource_type === 'client' && n.resource_id !== null) {
    return `/clients/detail/${n.resource_id}`;
  }
  return n.link ?? null;
}
